import angular from "angular";
import { AuthService } from "../services/auth/auth.service";
import { PerfilService } from "../services/perfil/perfil.service";

export class MainController {
  /**
   *
   * @param {angular.IScope} $rootScope
   * @param {angular.IScope} $scope
   * @param {angular.IQService} $q
   * @param {*} $uibModal
   * @param {*} $state
   * @param {angular.IWindowService} $window
   * @param {*} Pedido
   * @param {AuthService} Auth
   * @param {*} Utils
   * @param {*} localStorageService
   * @param {*} Cliente
   * @param {PerfilService} Perfil
   * @param {*} Notification
   * @param {*} Coleta
   * @param {string} TRACKSALE_KEY
   * @param {string} TRACKSALE_CAMPAIGN
   */
  constructor(
    $rootScope,
    $scope,
    $q,
    $uibModal,
    $state,
    $window,
    Financeiro,
    Pedido,
    Auth,
    Utils,
    localStorageService,
    Cliente,
    Perfil,
    Notification,
    Coleta,
    TRACKSALE_KEY,
    TRACKSALE_CAMPAIGN,
    AtendimentoResource
  ) {
    "ngInject";

    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.$q = $q;
    this.$uibModal = $uibModal;
    this.state = $state;
    this.$window = $window;
    this.Pedido = Pedido;
    this.Auth = Auth;
    this.Utils = Utils;
    this.localStorageService = localStorageService;
    this.Cliente = Cliente;
    this.Perfil = Perfil;
    this.Financeiro = Financeiro;
    this.Notification = Notification;
    this.Coleta = Coleta;
    this.TRACKSALE_KEY = TRACKSALE_KEY;
    this.TRACKSALE_CAMPAIGN = TRACKSALE_CAMPAIGN;
    this.AtendimentoResource = AtendimentoResource;

    this.betaPage = false;
    this.mostrarIconePainelAtendimento = false;
    this.qtdeAtendimentosAtualizados = 0;

    this.novoFinanceiro = false;
    this.faturaPendente = null;
    this.numeroFaturasPendentes = null;
    this.menuShow =
      $state.includes("finalizar-cadastro-documento") ||
      $state.includes("finalizar-cadastro-endereco");

    this.imageSrc = null;
    this.tipoServicoSelecionado = false;

    this.enderecoExemplo = {
      logradouro: "Endereço",
      numero: "Número",
      complemento: "",
      bairro: "Bairro",
      cep: "CEP",
      cidade: "Cidade",
      uf: "Estado",
      etiqueta: {
        remetente: "",
      },
    };

    this.destinatarioExemplo = {
      nome: "Nome Completo",
      endereco: this.enderecoExemplo,
    };

    this.$rootScope.$watch("hideMenu", (value) => {
      this.hideMenu = !!value;
    });

    $rootScope.vmMain = this;

    // atualiza a etiqueta quando o endereco do destinatario da remessa for alterado
    this.$scope.$on("etiqueta:destinatario:alterado", (event, data) => {
      this.destinatario = angular.copy(data);
    });

    // atualiza a etiqueta quando o endereco do remetente do pedido for alterado
    this.$scope.$on("etiqueta:remetente:alterado", (event, data) => {
      this.remetente = angular.copy(data);
    });

    // atualiza a etiqueta quando a Serviço de envio é alterada
    this.$scope.$on("etiqueta:formaEnvio:alterada", (event, data) => {
      const map = (tipo) => {
        switch (tipo) {
          case "Pac":
          case "MandaeEconomico":
            return "/assets/images/pac.png";
          case "Sedex":
          case "MandaeExpress":
            return "/assets/images/sedex.png";
          case "Sedex10":
            return "/assets/images/dia-seguinte.jpg";
          case "CartaRegistrada":
            return "/assets/images/carta.png";
          case "LogistaReversa":
            return "/assets/images/pre-pago.png";
          case "MandaeNormal":
            return "/assets/images/normal.png";
          case "MandaeUltraEconomico":
            return "/assets/images/ultra-economico.jpg";
          default:
            return null;
        }
      };

      this.imageSrc = map(data);
    });
  }

  async $onInit() {
    if (this.Auth.isLoggedIn()) {
      try {
        await this.$q.all(
          this.verificaFuncionalidades(),
          // this.exibeNotificacoes(),
          this.exibeColetaAtrasada(),
          this.carregaFaturasPendentes(),
          this.carregaPedido(),
        );
      } catch (err) {
        console.error(err);
      }
    }

    this.updateMenuData();
  }

  async verificaFuncionalidades() {
    const checkFeature = (features, feature) => {
      const a = features.find((f) => f.codigo === feature);
      return a && a.possuiAcesso;
    };
    try {
      const data = await this.Perfil.getBetaFeatures();
      const permissoes = data.funcionalidades;

      this.betaPage = checkFeature(permissoes, "impor_correios");
      this.novoFinanceiro = checkFeature(permissoes, "novo-painel-financeiro");
      this.mostrarIconePainelAtendimento = checkFeature(
        permissoes,
        "atendimento"
      );

      if (this.mostrarIconePainelAtendimento) {
        const totalAtendimentos = await this.AtendimentoResource.getTotalAtendimentosAtualizados()
          .$promise;
        this.qtdeAtendimentosAtualizados = totalAtendimentos.updatedTicketCount;
      }
    } catch (err) {
      console.error(err);
    }
  }

  async exibeNotificacoes() {
    try {
      const user = await this.Perfil.getUserData();
      const plan =
        user.planoContrato.tipo && user.planoContrato.tipo.toLowerCase();
      const isTrial = user.modoDemonstracao;
      if (plan === "soft") {
        this.$uibModal.open({
          animation: false,
          windowClass: "modal-soft-disabled",
          template: require("./modal/modal-soft-disabled/modal-soft-disabled.html"),
          controller: "ModalSoftDisabledCtrl as ctrl",
          backdrop: "static",
        });
      } else if (plan === "flex") {
        this.notification = {
          hideCloseBtn: true,
          force: true,
          message:
            "Atenção: a partir do dia 31/03/2018 não ofereceremos mais o plano Flex, ou seja, você poderá continuar utilizando nosso serviço de coleta, empacotamento e envio até 29/03/2018. Em caso de dúvidas, entre em contato conosco.",
        };
      } else if (isTrial) {
        this.notification = {
          hideCloseBtn: true,
          force: true,
          message:
            '<h4 class="m-bottom-sm">Sua conta está em modo demonstração e você pode criar pedidos de teste sem medo</h4>',
          description:
            "Após aprovação cadastral sua conta estará habilitada para criar pedidos",
          backgroundColor: "$m-purple",
        };
      } else {
        const dadosTracksale = {
          key: this.TRACKSALE_KEY,
          campaign: this.TRACKSALE_CAMPAIGN,
          email: user.email,
          name: user.nome,
        };

        try {
          const tracksaleInstance = new Tracksale();
          tracksaleInstance.init(dadosTracksale);
        } catch (i) {}

        this.notification = this.Notification.getNotification();
      }
    } catch (err) {
      console.error(err);
    }
  }

  async exibeColetaAtrasada() {
    const atrasada = await this.Coleta.isColetaAtrasada();
    if (atrasada) {
      this.notification = {
        hideCloseBtn: false,
        force: true,
        message: '<h4 class="m-bottom-sm">Falhamos na última coleta.</h4>',
        description:
          '<span class="p-bottom-sm">Entre em contato com nossa central de ajuda para verificar a causa e reprogramar seu agendamento.</span>',
        backgroundColor: "#ff7865",
      };
    }
  }

  async carregaFaturasPendentes() {
    try {
      // /v2/faturas (stack novo): limit/offset são obrigatórios; o total do envelope
      // é o COUNT(*) real com o filtro situacao=4 (faturas vencidas).
      const data = await this.Financeiro.getTotalFaturas({ situacao: 4, limit: 1, offset: 0 });
      this.qtdeFaturasPendentes = data.total;
      this.faturaPendente = this.qtdeFaturasPendentes > 0;
    } catch (e) {}
  }

  async carregaPedido() {
    try {
      const pedido = await this.Pedido.getPedidoAsync();

      this.pedido = pedido;
    } catch (err) {
      this.pedido = this.Pedido.getPedido();
    } finally {
      // obtem endereco de destinatario da primeira remessa ou do exemplo, o que existir
      if (
        this.pedido &&
        this.pedido.remessas &&
        this.pedido.remessas[0] &&
        this.pedido.remessas[0].destinatario
      ) {
        this.destinatario = Object.assign(
          {},
          this.pedido.remessas[0].destinatario
        );
      } else {
        this.destinatario = Object.assign({}, this.destinatarioExemplo);
      }

      // obtem endereco do remetente
      this.remetente = Object.assign(
        {},
        (this.pedido &&
          (this.pedido.enderecoEtiqueta || this.pedido.endereco)) ||
          this.Cliente.getUltimoEnderecoEtiqueta() ||
          this.Cliente.getUltimoEndereco() ||
          this.enderecoExemplo
      );
    }
  }

  dispararEvento(source) {}

  dispararEventoMenu(item) {

  }

  async logout() {
    this.showLoading = true;
    const eventos = {
      eventoMixpanel: "Menu",
    };

    try {
      await this.Auth.logout(eventos);

      this.$window.location.href = "/login";
    } catch (err) {
      this.$scope.error = err.data;
    }
  }

  updateMenuData() {
    const user = this.Auth.getCurrentUser();

    if (!user || !user.name) {
      this.userName = "";
      return;
    }

    const name = user.name;
    this.userName =
      this.Utils.getNome(name) + " " + this.Utils.getSobrenome(name);
  }

  // se tiver fora da area de pedido, ex: no historico ou rastreio, exibe um alerta no menu
  mostrarPedidoAtivo() {
    const pedido = this.localStorageService.get("ultimoPedido")
      ? this.localStorageService.get("ultimoPedido")
      : this.Pedido.getPedido();

    return (
      this.Auth.isLoggedIn() &&
      pedido.situacao == "Incompleta" &&
      pedido.remessas.length > 0 &&
      !this.state.includes("pedido")
    );
  }

  // se tiver pedido ativo redireciona para a lista de pedidos, se não cria novo pedido
  verificarPedido() {
    if (!this.Auth.isLoggedIn()) {
      return;
    }

    if (!this.state.is("pedido.encomenda.adicionar")) {
      this.Pedido.redirecionar();
    }
  }

  // trata as possiveis saidas de erros
  tratarErrosBackEnd(err) {
    this.$scope.errors = {};

    if (!err) {
      return;
    }

    if (err.erro) {
      return this.$scope.addAlert(err.erro);
    }

    if (err[0]) {
      return this.$scope.addAlert(err[0].message || err[0].erro);
    }

    if (err.data && err.data.erro) {
      return this.$scope.addAlert(err.data.erro);
    }

    if (err.data && err.data.length) {
      for (let erro in err.data) {
        this.$scope.$emit("erroEncontrado", err.data[erro].message);
      }
    }
  }

  mostraEtiqueta() {
    return [
      "pedido.encomendas",
      "pedido.veiculo",
      "pedido.pagamento",
      "pedido.resumo",
      "pedido.redirecionar",
    ].some((stateName) => this.state.current.name === stateName);
  }
}
